// extracted by mini-css-extract-plugin
module.exports = {"all_component":"HeaderSlider_all_component__P_Tvu","blood_banner":"HeaderSlider_blood_banner__1crMt"};